import { IMG } from "../data/images";

export const projects = [
  {
    slug: "deck-and-artificial-grass-transformation",
    title: "Deck & Artificial Grass Transformation",
    service: "decking",
    location: "Falkirk",
    before: "https://customer-assets.emergentagent.com/wingman/caccc4e9-89f6-4340-a43d-8fec52b62dd3/attachments/8c87b569cc614cec96914eeffbceed93_FB_IMG_1778509464279.jpg",
    after: "https://customer-assets.emergentagent.com/wingman/caccc4e9-89f6-4340-a43d-8fec52b62dd3/attachments/dba1ace87acf4563b22b2db354c77fef_FB_IMG_1778509466022.jpg",
    gallery: [IMG.deckAfter1, IMG.deckAfter2, IMG.deckBefore1, IMG.deckBefore2],
    summary: "Tired garden transformed with premium decking and lush artificial grass — a fully usable, low-maintenance outdoor living space.",
    details: "We stripped out the existing lawn and laid a properly-engineered timber sub-frame for the new decking area. The remaining garden was prepped with a full sub-base and finished with premium artificial grass for a beautiful, year-round, low-maintenance result.",
  },
  {
    slug: "stepping-stones-path",
    title: "Stepping Stones Path",
    service: "artificial-grass",
    location: "Edinburgh",
    before: IMG.steppingBefore,
    after: IMG.steppingStones,
    gallery: [IMG.steppingStones, IMG.steppingBefore],
    summary: "Bespoke stepping-stone walkway laid into premium artificial turf — defining flow with a feature path.",
    details: "Premium artificial turf installation with custom stepping stones laid into the surface. A landscape feature that lifts the entire garden and stays immaculate year-round.",
  },
  {
    slug: "playhouse-and-new-lawn",
    title: "Playhouse & New Lawn",
    service: "garden-makeovers",
    location: "Falkirk",
    before: IMG.playhouseBefore,
    after: IMG.playhouseAfter,
    gallery: [IMG.playhouseAfter, IMG.playhouseBefore],
    summary: "Family-friendly garden makeover with feature playhouse and lush new lawn.",
    details: "A complete transformation creating a safe, beautiful family space — featuring premium turf and a custom-positioned playhouse.",
  },
  {
    slug: "gravel-border-rectangular-lawn",
    title: "Gravel Border & Rectangular Lawn",
    service: "garden-design",
    location: "Glasgow",
    before: IMG.gravelBefore,
    after: IMG.gravelAfter,
    gallery: [IMG.gravelAfter, IMG.gravelBefore],
    summary: "Crisp rectangular lawn with defined gravel borders — clean lines and low maintenance.",
    details: "Garden redesigned with a precise rectangular lawn shape, defined gravel borders for easy upkeep, and structured planting for year-round interest.",
  },
  {
    slug: "large-garden-overhaul",
    title: "Large Garden Overhaul",
    service: "garden-makeovers",
    location: "Livingston",
    before: IMG.largeOverhaulBefore,
    after: IMG.largeOverhaulAfter,
    gallery: [IMG.largeOverhaulAfter, IMG.largeOverhaulBefore],
    summary: "Comprehensive garden transformation combining premium decking, artificial grass and gravel features.",
    details: "A full-scope project incorporating new decking, lush artificial turf and decorative gravel zones — turning a neglected garden into a multi-zoned outdoor living space.",
  },
  {
    slug: "concrete-to-deck-transformation",
    title: "Concrete to Deck Transformation",
    service: "decking",
    location: "Stirling",
    before: IMG.concreteDeckBefore,
    after: IMG.concreteDeckAfter,
    gallery: [IMG.concreteDeckAfter, IMG.concreteDeckBefore],
    summary: "Bare concrete slab converted into a beautiful, usable timber deck.",
    details: "Pressure-treated timber sub-frame installed over the existing concrete, finished with premium grooved decking boards for grip in Scottish weather.",
  },
  {
    slug: "artificial-grass-red-door-shed",
    title: "Artificial Grass & Red Door Shed",
    service: "artificial-grass",
    location: "Edinburgh",
    before: IMG.redDoorShed,
    after: IMG.redDoorShed,
    gallery: [IMG.redDoorShed],
    summary: "Premium artificial grass install framing a bespoke red-door garden shed feature.",
    details: "Clean, low-maintenance artificial turf layout designed around a feature garden shed — a tidy, family-friendly finish.",
  },
  {
    slug: "stone-path-and-artificial-grass",
    title: "Stone Path & Artificial Grass",
    service: "artificial-grass",
    location: "Glasgow",
    before: IMG.stonePathBefore,
    after: IMG.stonePathAfter,
    gallery: [IMG.stonePathAfter, IMG.stonePathBefore],
    summary: "Feature stone walkway integrated with premium artificial turf — a clean, modern garden line.",
    details: "Bespoke stone path laid through premium artificial grass — combining functional access with a high-end finish that stays pristine all year.",
  },
  {
    slug: "deck-and-lawn-completion",
    title: "Deck & Lawn Completion",
    service: "decking",
    location: "Falkirk",
    before: IMG.deckLawnBefore,
    after: IMG.deckLawnAfter,
    gallery: [IMG.deckLawnAfter, IMG.deckLawnBefore],
    summary: "Combined timber decking and fresh artificial lawn — full garden upgrade.",
    details: "Pressure-treated decking platform with premium artificial grass lawn — a complete back-garden transformation finished to a high standard.",
  },
  {
    slug: "white-gravel-border-turf",
    title: "White Gravel Border & Turf",
    service: "artificial-grass",
    location: "Stirling",
    before: IMG.whiteGravelTurf,
    after: IMG.whiteGravelTurf,
    gallery: [IMG.whiteGravelTurf],
    summary: "Premium artificial turf finished with a crisp white gravel border — clean, contemporary look.",
    details: "Sharp geometric lawn shape framed by a white gravel border for definition and zero-maintenance edging.",
  },
  {
    slug: "gravel-bordered-rectangular-lawn",
    title: "Gravel-Bordered Rectangular Lawn",
    service: "garden-design",
    location: "Livingston",
    before: IMG.gravelRectBefore,
    after: IMG.gravelRectAfter,
    gallery: [IMG.gravelRectAfter, IMG.gravelRectBefore],
    summary: "Sharp rectangular lawn framed by a gravel border — low-maintenance, high-impact.",
    details: "Geometric rectangular lawn with a precision-laid gravel border to keep edges sharp and weeding to a minimum.",
  },
  {
    slug: "garden-and-stone-path-transformation",
    title: "Garden & Stone Path Transformation",
    service: "garden-makeovers",
    location: "Edinburgh",
    before: IMG.gardenStoneBefore,
    after: IMG.gardenStoneAfter,
    gallery: [IMG.gardenStoneAfter, IMG.gardenStoneBefore],
    summary: "Full garden refresh with a feature stone walkway running through.",
    details: "Comprehensive garden makeover featuring a bespoke stone path, refreshed lawn area and tidied borders.",
  },
  {
    slug: "commercial-terrace-deck",
    title: "Commercial Terrace Deck & Turf",
    service: "commercial-landscaping",
    location: "Glasgow",
    before: IMG.terraceInProgress,
    after: IMG.restaurantTerrace,
    gallery: [IMG.restaurantTerrace, IMG.terraceInProgress],
    summary: "Commercial terrace install — premium decking and artificial turf for a hospitality client.",
    details: "Full commercial decking and artificial turf install for an outdoor terrace — finished to specification with attention to drainage, fall and safety. Shown here in build progress and final finish.",
  },
  {
    slug: "small-fenced-garden-transformation",
    title: "Small Fenced Garden Transformation",
    service: "garden-makeovers",
    location: "Edinburgh",
    before: IMG.smallFencedBefore,
    after: IMG.smallFencedAfter,
    gallery: [IMG.smallFencedAfter, IMG.smallFencedBefore],
    summary: "Compact urban garden completely transformed — fence, lawn and tidy borders.",
    details: "Small enclosed garden refreshed with new fencing, premium turf and tidy edges — proving that even compact spaces can feel premium with the right finishing.",
  },
  {
    slug: "large-garden-overhaul-panorama",
    title: "Large Garden Overhaul — Wide Panorama",
    service: "garden-makeovers",
    location: "Stirling",
    before: IMG.widePanoramaBefore,
    after: IMG.widePanoramaAfter,
    gallery: [IMG.widePanoramaAfter, IMG.widePanoramaBefore],
    summary: "Wide-format view of a full-scale garden overhaul — proper before-and-after scale.",
    details: "Panoramic view showing the entire scope of a large garden transformation — from tired, neglected plot to fully landscaped outdoor living space.",
  },
  {
    slug: "sloped-side-garden-transformation",
    title: "Sloped Side-Garden Transformation",
    service: "garden-makeovers",
    location: "Hamilton",
    before: IMG.slopedSideBefore,
    after: IMG.slopedSideAfter,
    gallery: [IMG.slopedSideAfter, IMG.slopedSideBefore],
    summary: "Awkward sloped side-garden reclaimed as a usable, low-maintenance space.",
    details: "Sloped side-of-house garden levelled, drained and finished with premium artificial turf — a high-impact upgrade to a previously unusable strip.",
  },
  {
    slug: "deck-dining-area-refresh",
    title: "Deck Dining Area Refresh",
    service: "decking",
    location: "Glasgow",
    before: IMG.deckDiningBefore,
    after: IMG.deckDiningAfter,
    gallery: [IMG.deckDiningAfter, IMG.deckDiningBefore],
    summary: "Tired outdoor dining deck restored to its premium best.",
    details: "Old timber decking refreshed and rebuilt where needed, finished to deliver a beautiful outdoor dining area for entertaining year-round.",
  },
  {
    slug: "kids-playhouse-playground-turf",
    title: "Kids Playhouse & Playground Turf",
    service: "artificial-grass",
    location: "Livingston",
    before: IMG.playgroundBefore,
    after: IMG.playgroundTurf,
    gallery: [IMG.playgroundTurf, IMG.playgroundBefore],
    summary: "Dedicated children's play zone with bespoke playhouse and soft-fall artificial turf.",
    details: "Family garden split into zones with a feature playhouse area set onto premium soft-fall rated artificial turf — safe, low-maintenance play for kids year-round.",
  },
  {
    slug: "small-garden-grey-fence",
    title: "Small Garden with Grey Fence",
    service: "fencing",
    location: "Edinburgh",
    before: IMG.greyFenceBefore,
    after: IMG.greyFenceAfter,
    gallery: [IMG.greyFenceAfter, IMG.greyFenceBefore],
    summary: "Contemporary grey fencing paired with a crisp new artificial lawn.",
    details: "Modern grey contemporary fencing installed with a freshly laid premium artificial turf — a low-maintenance, design-forward finish in a compact garden.",
  },
  {
    slug: "narrow-terrace-style-garden",
    title: "Narrow Terrace-Style Garden",
    service: "garden-makeovers",
    location: "Glasgow",
    before: IMG.narrowTerraceBefore,
    after: IMG.narrowTerraceAfter,
    gallery: [IMG.narrowTerraceAfter, IMG.narrowTerraceBefore],
    summary: "Long, narrow terrace garden reimagined with zoned premium finishes.",
    details: "Long, narrow plot transformed into a usable garden with clear zones — clever layout and premium materials making the most of every square metre.",
  },
  {
    slug: "stone-patio-lush-lawn",
    title: "Stone Patio & Lush Lawn",
    service: "patios",
    location: "Stirling",
    before: IMG.stonePatioBefore,
    after: IMG.stonePatioAfter,
    gallery: [IMG.stonePatioAfter, IMG.stonePatioBefore],
    summary: "Premium stone patio paired with a fresh, lush new lawn — classic Scottish garden upgrade.",
    details: "Natural stone patio laid on a full mortar bed with slurry primer, complemented by a freshly laid premium lawn area.",
  },
  {
    slug: "modern-deck-lawn-upgrade",
    title: "Modern Deck & Lawn Upgrade",
    service: "decking",
    location: "Edinburgh",
    before: IMG.modernDeckBefore,
    after: IMG.modernDeckAfter,
    gallery: [IMG.modernDeckAfter, IMG.modernDeckBefore],
    summary: "Contemporary timber decking combined with a crisp new artificial lawn — high-impact upgrade.",
    details: "Modern timber decking platform installed with concealed fixings and matched to a precisely-laid premium artificial turf for a sleek, contemporary finish.",
  },
  {
    slug: "large-deck-and-turf-area",
    title: "Large Deck & Turf Area",
    service: "decking",
    location: "Falkirk",
    before: IMG.largeDeckTurf,
    after: IMG.largeDeckTurf,
    gallery: [IMG.largeDeckTurf],
    summary: "Generous deck and artificial turf area — premium materials, ready for entertaining.",
    details: "Large timber decking area combined with premium artificial turf — a multi-zoned space designed for family use and entertaining.",
  },
  {
    slug: "premium-patio-artificial-grass",
    title: "Premium Patio & Artificial Grass",
    service: "patios",
    location: "Edinburgh",
    before: IMG.premiumPatioBefore,
    after: IMG.premiumPatioAfter,
    gallery: [IMG.premiumPatioAfter, IMG.premiumPatioBefore],
    summary: "Premium stone patio paired with a flawless artificial turf finish.",
    details: "Stone patio installed on a full mortar bed and brought together with premium artificial turf — a clean, contemporary, low-maintenance result.",
  },
  {
    slug: "playhouse-transformation",
    title: "Playhouse Transformation",
    service: "garden-makeovers",
    location: "Hamilton",
    before: IMG.playhouseTransformBefore,
    after: IMG.playhouseTransformAfter,
    gallery: [IMG.playhouseTransformAfter, IMG.playhouseTransformBefore],
    summary: "Tired garden reborn as a family-friendly play zone with feature playhouse.",
    details: "Comprehensive family-focused garden transformation centred around a feature playhouse, with safe, soft artificial turf surfaces and tidy borders.",
  },
  {
    slug: "deck-blue-slide-new-lawn",
    title: "Deck, Blue Slide & New Lawn",
    service: "garden-makeovers",
    location: "Falkirk",
    before: IMG.blueSlideBefore,
    after: IMG.blueSlideAfter,
    gallery: [IMG.blueSlideAfter, IMG.blueSlideBefore],
    summary: "Family-friendly garden with deck, feature blue slide and a brand-new lawn.",
    details: "Family garden split into a clear deck zone and lawn zone, finished with a feature playhouse and slide for the kids — premium materials, safe play surface throughout.",
  },
  {
    slug: "fenced-lawn-wooden-edging",
    title: "Fenced Lawn with Wooden Edging",
    service: "fencing",
    location: "Edinburgh",
    before: IMG.woodenEdgingBefore,
    after: IMG.woodenEdgingAfter,
    gallery: [IMG.woodenEdgingAfter, IMG.woodenEdgingBefore],
    summary: "Premium fenced lawn with bespoke wooden edging — clean lines, hard-wearing finish.",
    details: "Fenced perimeter installed and finished with bespoke wooden edging around a premium new lawn — durable, beautiful and built to handle Scottish weather.",
  },
  {
    slug: "long-rectangular-lawn-new-fence",
    title: "Long Rectangular Lawn & New Fence",
    service: "garden-makeovers",
    location: "Stirling",
    before: IMG.longLawnNewFence,
    after: IMG.longLawnNewFence,
    gallery: [IMG.longLawnNewFence],
    summary: "Long rectangular premium lawn flanked by a brand-new perimeter fence.",
    details: "Long-format garden completed with a precision-cut rectangular lawn and a complete new fence — built to last and easy to maintain.",
  },
  {
    slug: "front-garden-curb-appeal",
    title: "Front Garden Curb Appeal",
    service: "garden-design",
    location: "Edinburgh",
    before: IMG.frontCurbBefore,
    after: IMG.frontCurbAfter,
    gallery: [IMG.frontCurbAfter, IMG.frontCurbBefore],
    summary: "Premium front-garden turf and block edging — instant kerb-appeal lift.",
    details: "Front-of-house garden transformed with premium turf and clean block edging — the kind of upgrade that increases property value the moment a buyer pulls up.",
  },
  {
    slug: "back-garden-decking-artificial-grass",
    title: "Back Garden Decking & Artificial Grass Transformation",
    service: "garden-makeovers",
    location: "Glasgow",
    before: IMG.backDeckBefore,
    after: IMG.backDeckAfter,
    gallery: [IMG.backDeckAfter, IMG.backDeckBefore],
    summary: "Full back-garden makeover combining premium decking and artificial grass.",
    details: "Comprehensive back-garden transformation — timber decking platform paired with premium artificial turf and tidy border detailing.",
  },
  {
    slug: "fenced-garden-stone-edging",
    title: "Fenced Garden with Stone Edging",
    service: "garden-design",
    location: "Edinburgh",
    before: IMG.fencedStoneBefore,
    after: IMG.fencedStoneAfter,
    gallery: [IMG.fencedStoneAfter, IMG.fencedStoneBefore],
    summary: "Crisp fenced garden finished with premium stone edging — clean lines, hard-wearing.",
    details: "Fully fenced perimeter combined with bespoke stone edging around a premium lawn — built for durability and a clean, contemporary aesthetic.",
  },
  {
    slug: "house-side-lawn-transformation",
    title: "House Side Lawn Transformation",
    service: "artificial-grass",
    location: "Stirling",
    before: IMG.houseSideBefore,
    after: IMG.houseSideAfter,
    gallery: [IMG.houseSideAfter, IMG.houseSideBefore],
    summary: "Unused side strip of the house reclaimed as a premium turf space.",
    details: "Narrow side-of-house strip levelled, prepped with a full sub-base and finished with premium artificial turf — extending the usable garden area.",
  },
];

export const findProject = (slug) => projects.find((p) => p.slug === slug);
